import { Alert } from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';

import type { ChartRendererProps } from '../types.ts';

/**
 * Graceful UI fallback when a chart type has no registered renderer.
 *
 * `chartType` is constrained at the schema level (`ChartSchema`), and
 * `CHART_RENDERERS` is typed as `Record<ChartType, …>` so the lookup is
 * total under TypeScript. This component covers any future drift between
 * the schema enum and the renderer registry but does not signal back to
 * the agent — the schema is the single gate.
 */
export function UnsupportedChartRenderer({ config }: ChartRendererProps) {
  return (
    <Alert color="yellow" icon={<IconInfoCircle size={16} />} variant="light">
      Chart type "{config.chartType}" is not supported.
    </Alert>
  );
}
